import { fluid } from '@helpers/fluid';
import { baseGrid } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import { h2 } from '@helpers/typography';
import styled from 'styled-components';
const Container = styled.section `
  position: relative;
  display: block;
`;
const Grid = styled.div `
  ${baseGrid};
  position: relative;
  gap: ${fluid(12, 24)} 32px;
`;
const TitleArea = styled.div `
  grid-column: span 6;

  @media ${from(Device.TabletLarge)} {
    grid-column: span 12;
  }
`;
const Title = styled.h2 `
  ${h2};
  margin-bottom: 0;
`;
const ContentArea = styled.div `
  grid-column: span 6;

  @media ${from(Device.TabletLarge)} {
    grid-column: 2 / span 10;
  }

`;
const AccordionListStyles = {
    Container,
    ContentArea,
    Grid,
    Title,
    TitleArea,
};
export default AccordionListStyles;
